import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useIsMobile } from '../hooks/useResponsiveImage';

const heroImages = [
  {
    desktop: '/images/hero/business-signage.webp',
    mobile: '/images/hero/business-signage-mobile.webp',
  },
  {
    desktop: '/images/hero/large-format-printing.webp',
    mobile: '/images/hero/large-format-printing-mobile.webp',
  },
  {
    desktop: '/images/hero/office-branding.webp',
    mobile: '/images/hero/office-branding-mobile.webp',
  },
  {
    desktop: '/images/hero/print-marketing.webp',
    mobile: '/images/hero/print-marketing-mobile.webp',
  },
  {
    desktop: '/images/hero/promotional-products.webp',
    mobile: '/images/hero/promotional-products-mobile.webp',
  },
  {
    desktop: '/images/hero/vehicle-wrapping.webp',
    mobile: '/images/hero/vehicle-wrapping-mobile.webp',
  },
  {
    desktop: '/images/hero/web-services.webp',
    mobile: '/images/hero/web-services-mobile.webp',
  },
];

interface HeroSliderProps {
  autoPlayInterval?: number;
}

const HeroSlider: React.FC<HeroSliderProps> = ({
  autoPlayInterval = 5000,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const isMobile = useIsMobile();

  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !autoPlayInterval) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % heroImages.length);
    }, autoPlayInterval);

    return () => clearInterval(interval);
  }, [currentIndex, autoPlayInterval]);

  return (
    <div
      className="relative h-full w-full overflow-hidden"
      style={{ WebkitMaskImage: '-webkit-radial-gradient(white, black)' }}
    >
      {heroImages.map((image, index) => {
        const responsiveImage = isMobile ? image.mobile : image.desktop;

        return (
          <motion.div
            key={index}
            initial={false}
            animate={{
              opacity: index === currentIndex ? 1 : 0,
            }}
            transition={{
              duration: 2,
              ease: [0.22, 1, 0.36, 1],
            }}
            className="absolute inset-0"
            style={{
              zIndex: index === currentIndex ? 1 : 0,
            }}
          >
            <img
              src={responsiveImage}
              alt="DKSN Business Solutions showcase"
              className="h-full w-full object-cover"
            />
            {/* Gradient overlay */}
            <div
              className="absolute inset-0"
              style={{
                background:
                  'linear-gradient(180deg, rgba(5,8,15,0.55) 0%, rgba(5,8,15,0.25) 40%, rgba(5,8,15,0.92) 88%, #05080F 100%)',
              }}
            />
            <div className="absolute inset-0 bg-[radial-gradient(1000px_600px_at_20%_80%,rgba(91,141,239,0.22),transparent_60%)]" />
          </motion.div>
        );
      })}
    </div>
  );
};

export default HeroSlider;
